import React from 'react';
import { useParams } from 'react-router-dom';
import SubMasterManager from './SubMasterManager';
import UOMManager from './UOMManager';
import CurrencyManager from './CurrencyManager';

// Map route slug to human-friendly title and internal type key
const TYPE_MAP = {
  // product master
  category: { type: 'category', title: 'Category' },
  'product-name': { type: 'product-name', title: 'Product Name' },
  collection: { type: 'collection', title: 'Collection' },
  materials: { type: 'materials', title: 'Materials' },
  'hs-code': { type: 'hs-code', title: 'HS Code' },
  color: { type: 'color', title: 'Color' },
  finish: { type: 'finish', title: 'Finish' },
  'suitable-for': { type: 'suitable-for', title: 'Suitable For' },
  'pack-type': { type: 'pack-type', title: 'Pack Type' },

  // buyer ledger creation
  'ledger-group': { type: 'ledger-group', title: 'Ledger Group' },
  currency: { type: 'currency', title: 'Currency', isCurrency: true },
  'ingo-term': { type: 'ingo-term', title: 'INGO Term' },
  'client-to': { type: 'client-to', title: 'Client To' },
  agency: { type: 'agency', title: 'Agency' },
  'payment-term': { type: 'payment-term', title: 'Payment Term' },
  'barcode-type': { type: 'barcode-type', title: 'Barcode Type' },

  // UOM (Unit of Measurement) types
  'uom-weight': { type: 'uom-weight', title: 'UOM - Weight', isUOM: true },
  'uom-count': { type: 'uom-count', title: 'UOM - Count', isUOM: true },
  'uom-dimension': { type: 'uom-dimension', title: 'UOM - Dimension', isUOM: true },
  'uom-volume': { type: 'uom-volume', title: 'UOM - Volume', isUOM: true },
  'uom-loadability': { type: 'uom-loadability', title: 'UOM - Loadability', isUOM: true },
};

// Determine which manager component to use based on type
const getManagerComponent = (mapped) => {
  if (mapped.isUOM) return UOMManager;
  if (mapped.isCurrency) return CurrencyManager;
  return SubMasterManager;
};

const SubMastersPage = () => {
  const { type: slug } = useParams();
  const mapped = TYPE_MAP[slug] || { type: slug, title: slug };

  const ManagerComponent = getManagerComponent(mapped);

  return (
    <div className="p-5">
      <ManagerComponent type={mapped.type} title={mapped.title} />
    </div>
  );
};

export default SubMastersPage;
